export default __webpack_public_path__ + "static/media/icon-nav-frat.77704c2d.svg";